import React from 'react'

function LifeScience() {
  return (
    <div>LifeScience</div>
  )
}

export default LifeScience